'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "url", "external", "useZorse", "zorseOptions", "onClick"];
import { Component } from 'react';
import hubspot from 'hubspot';
import { Button } from 'foundations-components/transitional/components/Button';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { getKnowledgeBaseUrl } from '../internal/utils/getLangCodeSpecificUrls';
import { jsx as _jsx } from "react/jsx-runtime";
export default class KnowledgeBaseButton extends Component {
  constructor(...args) {
    super(...args);
    this.getZorseCaller = useZorse => {
      return useZorse && hubspot.zorse && hubspot.zorse.openHelpWidget;
    };
    this.handleClick = event => {
      const {
        onClick,
        useZorse,
        zorseOptions,
        url
      } = this.props;
      const localeUrl = getKnowledgeBaseUrl(url);
      const openZorse = this.getZorseCaller(useZorse);
      if (openZorse) {
        event.preventDefault();
        openZorse(Object.assign({
          url: localeUrl
        }, zorseOptions));
      }
      if (onClick) {
        onClick(event);
      }
    };
  }
  render() {
    const _this$props = this.props,
      {
        children,
        url,
        external,
        useZorse
      } = _this$props,
      passThroughProps = _objectWithoutPropertiesLoose(_this$props, _excluded);
    const localeUrl = getKnowledgeBaseUrl(url);
    const linkProps = {};
    linkProps.external = typeof external === 'boolean' ? external : !this.getZorseCaller(useZorse);
    linkProps.href = localeUrl;
    linkProps.onClick = this.handleClick;
    return /*#__PURE__*/_jsx(Button, Object.assign({}, passThroughProps, linkProps, {
      children: children
    }));
  }
}
KnowledgeBaseButton.defaultProps = {
  children: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "i18nAddon.supportLink.learnMore"
  }),
  use: 'link',
  useZorse: false,
  zorseOptions: {}
};